import { createFileRoute } from '@tanstack/react-router';
import Profile from '@piwikpro/user-panel/src/components/Profile';

export const Route = createFileRoute('/_secured/profile/')({
  component: Profile,
});
